<div>
  <h1>
    Login
  </h1>
  <div id="stage1" [class]="(!stage1?'hideMe':'')">
    <form id="userData" action="" method="POST" autocomplete="off">
      <label>login page in no longer available ,please Use Engagement and Projects  portal login page.</label>
      <!-- <label><span>User Name</span><input type="text" name="userName" autocomplete="off" placeholder="Enter your username" [(ngModel)]="loginModel.username"  /></label>
      <label><span>Password</span><input type="password" name="Password" autocomplete="new-password" placeholder="Enter your password" [(ngModel)]="loginModel.password" /></label>
      <div> 
        <button class="k-button cvt-primary" (click)="login($event)">Login</button>
        <span *ngIf="false">
          <button class="k-button cvt-secondary" (click)="userInfo()">UserInfo</button>
          <button class="k-button cvt-secondary" (click)="logout()">Logout</button>
        </span>
      </div> 
      <ri-error-summary [errors]="errors"></ri-error-summary>
      <input type="submit" id="logout" value="Logout" /> -->
    </form>
  </div>
  <div id="stage2" [class]="(stage1?'hideMe':'')">
    <div>
      <kendo-dropdownlist  #list [data]="customerSelectionList" valueField="id"
      textField="name"
      [value]="selectedCustomer" (selectionChange)="OnCustomerChanged($event)"
        [allowCustom]="false" [popupSettings]="customerDropdownPopupSettings" >
      </kendo-dropdownlist>
    </div>
    <div>
      <button class="k-button cvt-primary" (click)="customerConfirmed()">Login</button>
      <button class="k-button cvt-secondary" (click)="logout()">Cancel</button>
    </div>
    <ri-error-summary [errors]="errors"></ri-error-summary>
  </div>
</div>
